import { BaseCondition } from '../conditions/base-condition';
import { FeatureInjector } from '../services/feature-injector/feature-injector.service';

export function FeatureValue(conditions: BaseCondition | Array<BaseCondition>) {
  return function(target: any, propertyKey: string) {
    function evaluateFeatureValue() {
      if (!FeatureInjector.featureDecisionService) {
        console.warn(`FeatureInjector n'est pas initialisé. La valeur de ${propertyKey} sera null`);
        return null;
      }

      return FeatureInjector.featureDecisionService.evaluate(conditions);
    }

    Object.defineProperty(target, propertyKey, {
      get: evaluateFeatureValue,
      enumerable: true,
      configurable: true
    });
  };
}
